import { AdPlatform, CampaignType, TABLE_PLATFORM_FILTER, TableColumnConfig } from '@app/core/models/common.models';

export enum CriterionAdditionMatchType {
  Broad = 'BROAD',
  Exact = 'EXACT',
  Phrase = 'PHRASE',
}

export enum CriterionAdditionProposalType {
  Addition = 'ADDITION',
  Exclusion = 'EXCLUSION',
}

export enum CriterionAdditionProposalReason {
  CheapClick = 'CHEAP-CLICK',
  HighClickValue = 'HIGH-CLICK-VALUE',
  HighCTR = 'HIGH-CTR',
  HighVolume = 'HIGH-VOLUME',
  LowClickValue = 'LOW-CLICK-VALUE',
  OneConversion = 'ONE-CONVERSION',
}

export enum CriterionAdditionProposalState {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  REVIEW = 'REVIEW',
}

export enum CriterionAdditionForcedReviewReason {
  InvalidDestinations = 'INVALID-DESTINATIONS',
  MultipleRulesMatched = 'MULTIPLE-RULES-MATCHED',
}

export enum CriterionAdditionCriterionType {
  Keyword = 'KEYWORD',
  KeywordTheme = 'KEYWORD-THEME',
  MobileApplication = 'MOBILE-APPLICATION',
  Pat = 'PAT',
  Placement = 'PLACEMENT',
  YoutubeChannel = 'YOUTUBE-CHANNEL',
  YoutubeVideo = 'YOUTUBE-VIDEO',
}

export enum CriterionAdditionCriterionSubtype {
  Asin = 'ASIN',
  Category = 'CATEGORY',
  Domain = 'DOMAIN',
  Url = 'URL',
}

// @todo check if these could be made lowercase
export enum CriterionAdditionSettingMode {
  Simple = 'SIMPLE',
  Advanced = 'ADVANCED',
}

export enum CriterionAdditionEnforceAdvanced {
  True = 'true',
  False = 'false',
}

export enum CriterionAdditionSettingLevel {
  Customer = 'CUSTOMER',
  Account = 'ACCOUNT',
}

export enum CriterionAdditionSettingType {
  Mode = 'MODE',
  SimpleModeAction = 'SIMPLE-MODE-ACTION',
  EnforceAdvancedMode = 'ENFORCE-ADVANCED-MODE',
}

export enum CriterionAdditionSettingValueType {
  Boolean = 'BOOLEAN',
  Enum = 'ENUM',
  Integer = 'INTEGER',
}

export type CriterionAdditionCampaignType =
  | Extract<
      CampaignType,
      | 'AMAZON-SPONSORED-BRANDS'
      | 'AMAZON-SPONSORED-DISPLAY'
      | 'EBAY-PROMOTED-LISTINGS-ADVANCED'
      | 'GOOGLE-DISPLAY'
      | 'GOOGLE-SEARCH'
      | 'GOOGLE-SHOPPING'
      | 'MICROSOFT-SEARCH'
      | 'MICROSOFT-SHOPPING'
      | 'WALMART-SPONSORED-BRANDS'
      | 'WALMART-SPONSORED-PRODUCTS'
      | 'WALMART-SPONSORED-VIDEO'
    >
  | 'AMAZON-SPONSORED-PRODUCTS-AUTO'
  | 'AMAZON-SPONSORED-PRODUCTS-MANUAL';

export interface CriterionAdditionSettings {
  settingType: CriterionAdditionSettingType;
  settingValueType: CriterionAdditionSettingValueType;
  settingValue: string;
  settingValueInherited: boolean;
  // searchable
  adspertAccountId: number | null;
  // searchable
  accountId: string | null;
  // searchable
  accountName: string | null;
  accountPlatform: AdPlatform | null;
  accountOptimize: boolean | null;
  // searchable
  accountTagsUser: string[] | null;
  accountIsDemo: boolean | null;

  level?: CriterionAdditionSettingLevel;
}

export interface CriterionAdditionSettingPayload {
  settingType: CriterionAdditionSettingType.SimpleModeAction;
  settingValue: string;
  adspertAccountId: number | null;
}

export const CriterionAdditionSettingsTableColumns: TableColumnConfig<CriterionAdditionSettings>[] = [
  {
    key: 'accountPlatform',
    displayName: 'accountPlatform',
    width: 80,
    align: 'center',
    filterable: true,
    filterOptions: TABLE_PLATFORM_FILTER,
    sortable: true,
  },
  {
    key: 'accountName',
    displayName: 'accountName',
    width: 400,
    align: 'left',
    sortable: true,
    defaultSort: 1,
  },
  {
    key: 'details',
    displayName: 'details',
    excludeInURI: true,
    width: 250,
    align: 'left',
  },
];
